const RightContainer = () => {
    return (
        <div className="hidden lg:block w-full h-screen sticky top-0 p-[40px]">
            {/* Added 'flex flex-col' to easily stack text and image */}
            <div className="xw-full h-full rounded-[20px] overflow-hidden relative flex flex-col">

                {/* Text Wrapper - kept z-index just in case you add absolute backgrounds later */}
                {/* <div className="relative z-10 shrink-0">
                    <p className="text-heading2 text-white">A click away to get custom solutions</p>
                    <p className="text-heading6 text-white mt-[8px]">A sneak peek of effortless workflow</p>
                </div> */}

                {/* Image Wrapper - 'flex-1' makes it take up exactly the remaining height */}
                <div className="relative flex-1 w-full mt-8 overflow-hidden rounded-xl">
                    <img
                        src="/images/Hero-portal.jpg"
                        alt="Dashboard"
                        // object-cover prevents stretching. object-top anchors the image to the top.
                        className="absolute inset-0 w-full h-full object-cover object-top"
                    />
                </div>

            </div>
        </div>
    );
};

export default RightContainer;